<template>
  <div>
    <div class="p-2 ">
      <div class="flex space-x-2 mb-2 flex-1 items-center">
        <router-link to="/quizbuilder"
          ><span class="global-button">
            Yeni Anket Oluştur
          </span></router-link
        >
      </div>
    </div>

    <div v-if="activeQuestion" class="border rounded-lg p-2">
      <div @click="activeQuestion = 0" class=" text-xs global-button w-20 my-2">
        <svg class="h-6 w-6" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M10 22L0 12L10 2l1.775 1.775L3.55 12l8.225 8.225Z"
          />
        </svg>
        <span>Geri</span>
      </div>
      <h2 class="p-0 m-0 text-xl font-bold px-2">{{ activeQuestionName }}</h2>
      <form @submit.prevent="setAnswers()" method="post">
        <div
          class="p-2 border-b"
          v-for="(question, questionIndex) in activeQuestionData"
        >
          <div v-if="question.type == 'Girdi'">
            <label class="lbl">{{ question.text }}</label>
            <input
              :name="questionIndex"
              class="uk-input"
              v-model="form[questionIndex].value"
              type="text"
            />
          </div>
          <div v-else-if="question.type == 'Seçenek'">
            <label class="lbl">{{ question.text }}</label>
            <div class="scnk">
              <label
                v-for="(answers, answerIndex) in question.answers"
                :value="answers.text"
                >{{ answers.text }}
                <input
                  type="radio"
                  :name="questionIndex"
                  v-model="form[questionIndex].value"
                  :value="answers.text"
              /></label>
            </div>
          </div>
          <div v-else-if="question.type == 'ÇokluSeçenek'">
            <label class="lbl">{{ question.text }}</label>
            <div class="scnk">
              <label
                v-for="(answers, answerIndex) in question.answers"
                :value="answers.text"
                >{{ answers.text }}
                <input
                  type="checkbox"
                  :true-value="[]"
                  :name="questionIndex"
                  v-model="form[questionIndex].value"
                  :value="answers.text"
              /></label>
            </div>
          </div>
          <div v-else-if="question.type == 'Evet/Hayır'">
            <label class="lbl">{{ question.text }}</label>
            <div class="scnk">
              <label
                >EVET
                <input
                  :name="questionIndex"
                  v-model="form[questionIndex].value"
                  type="radio"
                  value="evet"
              /></label>
              <label
                >HAYIR
                <input
                  :name="questionIndex"
                  v-model="form[questionIndex].value"
                  type="radio"
                  value="hayır"
              /></label>
            </div>
          </div>
        </div>
        <button type="submit" class=" primary-button mt-4">
          Gönder
        </button>
      </form>
    </div>
    <div v-else>
      <table
        v-if="loading == false"
        class="
          uk-table
          journal-table
          uk-table-hover
          heightoverflow
          uk-table-middle uk-table-divider
        "
      >
        <tr>
          <th>ADI</th>
          <th>OLUŞTURULMA TARİHİ</th>
          <th>DURUM</th>
        </tr>
        <tr v-for="quest in questions">
          <td>{{ quest.name }}</td>
          <td>{{ quest.created_at }}</td>
          <td>
            <span
              v-if="!quest.answers"
              @click="activeQuestionSet(quest)"
              class="primary-button"
              >Cevapla</span
            >
            <span v-else @click="showAnswers(quest)" class="green-button"
              >Cevapları Gör</span
            >
          </td>
        </tr>
      </table>

      <div v-else class="center">
        <vk-spinner ratio="2"></vk-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from "../../../services/http";
export default {
  data() {
    return {
      questions: [],
      answers: [],
      form: [],
      activeQuestionData: [],
      activeQuestion: 0,
      activeQuestionName: "",
      loading: true
    };
  },
  props: ["id"],
  mounted() {
    this.getData();
  },
  methods: {
    activeQuestionSet(question) {
      this.activeQuestion = question.id;
      this.activeQuestionName = question.name;
      this.activeQuestionData = JSON.parse(question.data);
      this.form = this.activeQuestionData.map(e => {
        return { text: e.text, value: "" };
      });
    },
    getData() {
      httpService.questions(this.id).then(response => {
        this.questions = response.data.questions;

        this.questions = this.questions.map(ques => {
          if (response.data.answers) {
            ques.answers = response.data.answers.find(
              e => e.question_id == ques.id
            );
            if (ques.answers) {
              ques.answers = ques.answers.answers;
            }
          }

          return ques;
        });
        this.loading = false;
      });
    },

    showAnswers(question) {
      this.activeQuestion = question.id;
      this.activeQuestionName = question.name;
      this.activeQuestionData = JSON.parse(question.data);
      let answers = JSON.parse(question.answers);
      this.form = answers.map(e => {
        return { text: e.text, value: e.value };
      });
    },
    setAnswers() {
      httpService
        .answerSet(this.id, {
          question_id: this.activeQuestion,
          answers: this.form
        })
        .then(result => {
          this.$root.successMessage("İşlem başarıyla kaydedildi");
          setTimeout(() => {
            location.reload();
          }, 1000);
        });
    }
  }
};
</script>
<style>
.lbl {
  @apply block;
}

.scnk {
  @apply flex items-center space-x-2;
}

.scnk label {
  @apply border p-1 mr-1 space-x-2 rounded;
}
</style>
